"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.defaultGetInput = defaultGetInput;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireDefault(require("../index"));
var _TextInput = _interopRequireDefault(require("../../TextInput"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _EditableTableContext = require("./EditableTableContext");
var _util = require("./../util");
var _EditableCell = _interopRequireDefault(require("./EditableCell"));
var _SingleEditableCell = _interopRequireDefault(require("./SingleEditableCell"));
var _EditableRow = _interopRequireDefault(require("./EditableRow"));
var _excluded = ["columns", "data", "setData", "onEditingKeyChange", "ondataIndexChange", "pagination", "mode", "getInput", "mapValuesFromForm", "mapValuesToForm", "className", "onCellChange", "onRowChange", "onChange", "handleEditSubmit", "handleEditCancel", "editOnFocus", "rowKey", "focusedHighlight"],
  _excluded2 = ["rowKey"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function defaultGetInput(dataIndex, record, props, type) {
  return /*#__PURE__*/_react.default.createElement(_TextInput.default, props);
}
function defaultMapValuesFromForm(values) {
  return values;
}
function defaultMapValuesToForm(values) {
  return values;
}
function EditableTable(props) {
  var columnsFromProps = props.columns,
    data = props.data,
    setData = props.setData,
    onEditingKeyChange = props.onEditingKeyChange,
    ondataIndexChange = props.ondataIndexChange,
    _props$pagination = props.pagination,
    pagination = _props$pagination === void 0 ? {} : _props$pagination,
    mode = props.mode,
    _props$getInput = props.getInput,
    getInput = _props$getInput === void 0 ? defaultGetInput : _props$getInput,
    _props$mapValuesFromF = props.mapValuesFromForm,
    mapValuesFromForm = _props$mapValuesFromF === void 0 ? defaultMapValuesFromForm : _props$mapValuesFromF,
    _props$mapValuesToFor = props.mapValuesToForm,
    mapValuesToForm = _props$mapValuesToFor === void 0 ? defaultMapValuesToForm : _props$mapValuesToFor,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    onCellChange = props.onCellChange,
    onRowChange = props.onRowChange,
    onChange = props.onChange,
    handleEditSubmit = props.handleEditSubmit,
    handleEditCancel = props.handleEditCancel,
    editOnFocus = props.editOnFocus,
    rowKey = props.rowKey,
    focusedHighlight = props.focusedHighlight,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  // set editting key used by another function
  var _useEditableTableForm = (0, _EditableTableContext.useEditableTableForm)(),
    form = _useEditableTableForm.form,
    editingKey = _useEditableTableForm.editingKey,
    setEditingKey = _useEditableTableForm.setEditingKey,
    selectedDataIndex = _useEditableTableForm.selectedDataIndex,
    setSelectedDataIndex = _useEditableTableForm.setSelectedDataIndex,
    isRowEditing = _useEditableTableForm.isRowEditing,
    dataIndexRef = _useEditableTableForm.dataIndexRef,
    keyRef = _useEditableTableForm.keyRef;
  var containerRef = (0, _react.useRef)(null);
  var submitingElementClassName = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    columns = _useState2[0],
    setColumns = _useState2[1];
  var isCellMode = mode === 'cell';

  //#region methods
  var onInputBlur = (0, _react.useCallback)(function (record, dataIndex) {
    // submitingElementClassName.current = `editable-cell-${record.key}-${dataIndex}`;
    setTimeout(function () {
      var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
      if (keyRef.current === key && dataIndexRef.current === dataIndex) {
        setEditingKey('');
        setSelectedDataIndex(null);
        if (typeof rest.onInputBlur == "function") rest.onInputBlur(dataIndex);
      }
    }, 500);
  }, [rest.onInputBlur]);
  var onInputFocus = (0, _react.useCallback)(function (record, dateIndex) {
    var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndexRef);
    submitingElementClassName.current = "editable-cell-".concat(key, "-").concat(dateIndex);
    if (typeof rest.onInputFocus == "function") rest.onInputFocus(dateIndex);
  }, [rest.onInputFocus]);
  var newValueForRow;
  var _getNewData = function getNewData(data, key, mappedValues) {
    var newData = data.map(function (item, index) {
      var recordKey = (0, _util.getRecordKeyByRowKey)(rowKey, item, index);
      if (recordKey === key) {
        newValueForRow = _objectSpread(_objectSpread({}, item), mappedValues);
        return newValueForRow;
      } else if (item.children && item.children.length > 0) {
        item.children = _getNewData(item.children, key, mappedValues)[0];
      }
      return item;
    });
    return [newData, newValueForRow];
  };
  var _getItemByTreeDataSelection = function getItemByTreeDataSelection(data, key, mappedValues) {
    if (!isCellMode) return null;
    var selectedItem = null;
    if (data) {
      for (var index = 0; index < data.length; index++) {
        if (selectedItem !== null) break;
        var item = data[index];
        if (item.key === key) {
          selectedItem = item;
          break;
        } else if (item.children && item.children.length > 0) {
          selectedItem = _getItemByTreeDataSelection(item.children, key, mappedValues);
        }
      }
    }
    return selectedItem;
  };
  var save = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(key, rowValue) {
      var row, mappedValues, _getNewData2, _getNewData3, newData, newValueForRow, newValueForCell;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return form.current.validateFields();
          case 2:
            row = _context.sent;
            _context.next = 5;
            return mapValuesFromForm(_objectSpread(_objectSpread({}, rowValue !== null && (0, _typeof2.default)(rowValue) === 'object' ? rowValue : row), {}, {
              key: key
            }));
          case 5:
            mappedValues = _context.sent;
            _getNewData2 = _getNewData(data, key, mappedValues), _getNewData3 = (0, _slicedToArray2.default)(_getNewData2, 2), newData = _getNewData3[0], newValueForRow = _getNewData3[1]; // call listeners
            if (!(onRowChange && newValueForRow)) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return onRowChange(key, newValueForRow);
          case 10:
            newValueForCell = _getItemByTreeDataSelection(newData, key, mappedValues); //changed column item for tree data selection,
            if (!(isCellMode && onCellChange && (newValueForRow || newValueForCell != null))) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return onCellChange(key, Object.keys(mappedValues)[0], newValueForCell == null ? newValueForRow : newValueForCell);
          case 14:
            // cell mode handles key changes on blur & focus
            if (!isCellMode) {
              setEditingKey('');
            }
            setData(newData);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [data]);

  // handle submit methodu içerisinden tekrar validation tetikleme işlemi için eklendi
  var triggerValidation = function triggerValidation() {
    return new Promise(function (resolve) {
      form.current.validateFields(function (errors, values) {
        resolve({
          errors: errors,
          values: values
        });
      });
    });
  };
  var handleSubmit = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(e) {
      var callbackFn, mappedValues;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            e.preventDefault();
            callbackFn = /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return save(editingKey);
                    case 2:
                      if (isCellMode) {
                        setTimeout(function () {
                          setEditingKey('');
                          setSelectedDataIndex(null);
                        }, 500);
                      }
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function callbackFn() {
                return _ref3.apply(this, arguments);
              };
            }(); // prompt
            if (!handleEditSubmit) {
              _context3.next = 9;
              break;
            }
            _context3.next = 5;
            return mapValuesFromForm(form.current.getFieldsValue());
          case 5:
            mappedValues = _context3.sent;
            handleEditSubmit(callbackFn, mappedValues, triggerValidation, editingKey);
            _context3.next = 10;
            break;
          case 9:
            callbackFn();
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [data, editingKey, handleEditSubmit]);
  var handleSubmitClick = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(row, index) {
      var recordKey, callbackFn, mappedValues;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            recordKey = (0, _util.getRecordKeyByRowKey)(rowKey, row, index);
            callbackFn = /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4() {
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return save(recordKey);
                    case 2:
                      if (isCellMode) {
                        setTimeout(function () {
                          setEditingKey('');
                          setSelectedDataIndex(null);
                        }, 500);
                      }
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function callbackFn() {
                return _ref5.apply(this, arguments);
              };
            }();
            if (!handleEditSubmit) {
              _context5.next = 9;
              break;
            }
            _context5.next = 5;
            return mapValuesFromForm(form.current.getFieldsValue());
          case 5:
            mappedValues = _context5.sent;
            handleEditSubmit(callbackFn, mappedValues, triggerValidation, recordKey);
            _context5.next = 10;
            break;
          case 9:
            callbackFn();
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }(), [data, editingKey, handleEditSubmit]);
  var onRow = (0, _react.useCallback)(function (record, index) {
    return {
      index: index,
      record: record
    };
  }, []);
  var cancel = (0, _react.useCallback)(function (rowData) {
    if (form.current) {
      form.current.resetFields();
    }
    setEditingKey('');
    setSelectedDataIndex(null);
    if (handleEditCancel) {
      handleEditCancel(rowData);
    }
  }, []);
  var onTableChange = (0, _react.useCallback)(function () {
    cancel();
    if (onChange) {
      onChange.apply(void 0, arguments);
    }
  }, [onChange, cancel]);

  //#endregion

  //#region column related manipulations
  var renderEditRowAction = (0, _react.useCallback)(function (value, row, index) {
    var _props$theme, _props$theme$table, _props$theme$table$ac, _props$theme2, _props$theme2$table, _props$theme2$table$a;
    var cls = "table-action-button";
    var iconSize = ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$table = _props$theme.table) === null || _props$theme$table === void 0 ? void 0 : (_props$theme$table$ac = _props$theme$table.action[props.size]) === null || _props$theme$table$ac === void 0 ? void 0 : _props$theme$table$ac.iconSize) || ((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$table = _props$theme2.table) === null || _props$theme2$table === void 0 ? void 0 : (_props$theme2$table$a = _props$theme2$table.action) === null || _props$theme2$table$a === void 0 ? void 0 : _props$theme2$table$a.iconSize) || 24;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "ghost",
      className: cls,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        handleSubmitClick(row, index);
      },
      tabIndex: "0"
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      placement: "top",
      overlay: props.locale.save
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: 'check',
      colorType: 'success',
      size: iconSize
    })))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "ghost",
      className: cls,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        cancel(row);
      },
      tabIndex: "0"
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      placement: "top",
      overlay: props.locale.cancel
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: 'close',
      colorType: 'default',
      size: iconSize
    })))));
  }, [save, cancel, props.locale]);
  function getNestedColumns(columns) {
    var results = [];
    var _filterColumns = function filterColumns(items) {
      items === null || items === void 0 ? void 0 : items.forEach(function (item) {
        if (item.children) {
          _filterColumns(item.children);
        } else {
          results.push(item);
        }
      });
    };
    _filterColumns(columns);
    return results;
  }
  function mapColums(columnsDef) {
    if (!columnsDef) {
      return [];
    }
    var firstEditableDataIndex;
    var lastEditableDataIndex;
    var nestedColumns = getNestedColumns(columnsDef);
    var editableColumns = nestedColumns.filter(function (col) {
      return col.editable === true;
    });
    if (editableColumns.length > 0) {
      // @ts-ignore: Object is possibly 'null'.
      lastEditableDataIndex = editableColumns.pop().dataIndex;
    }
    var _modifyColumns = function modifyColumns(col, index) {
      if (!isCellMode && col.type && col.type.action) {
        if (col.type.action === 'edit') {
          var _props$theme3, _props$theme3$table, _props$theme3$table$a, _props$theme3$table$a2, _props$theme4, _props$theme4$table, _props$theme4$table$a, _props$theme4$table$a2;
          var columnWidth = ((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : (_props$theme3$table = _props$theme3.table) === null || _props$theme3$table === void 0 ? void 0 : (_props$theme3$table$a = _props$theme3$table.action[props.size]) === null || _props$theme3$table$a === void 0 ? void 0 : (_props$theme3$table$a2 = _props$theme3$table$a.edit) === null || _props$theme3$table$a2 === void 0 ? void 0 : _props$theme3$table$a2.width) || ((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : (_props$theme4$table = _props$theme4.table) === null || _props$theme4$table === void 0 ? void 0 : (_props$theme4$table$a = _props$theme4$table.action) === null || _props$theme4$table$a === void 0 ? void 0 : (_props$theme4$table$a2 = _props$theme4$table$a.edit) === null || _props$theme4$table$a2 === void 0 ? void 0 : _props$theme4$table$a2.width) || 74;
          return _objectSpread(_objectSpread({}, col), {}, {
            // tested this is the min. width works properly
            width: columnWidth,
            type: _objectSpread(_objectSpread({}, col.type), {}, {
              handler: function handler(record, e, rowIndex) {
                var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, rowIndex);
                setEditingKey(key);
                if (col.type.handler) {
                  col.type.handler(record, e, rowIndex);
                }
              },
              isEditing: isRowEditing,
              render: renderEditRowAction
            })
          });
        }
      }
      if (col.children) {
        col.children = col.children.map(_modifyColumns);
      }
      if (!col.editable) {
        return col;
      }
      if (!firstEditableDataIndex) {
        firstEditableDataIndex = col.dataIndex;
      }
      return _objectSpread(_objectSpread({}, col), {}, {
        onCell: function onCell(record) {
          return {
            record: record,
            index: index,
            disabled: col.disabled,
            viewMode: col.viewMode,
            editable: typeof col.editable == 'function' ? col.editable(record) : col.editable,
            isFirstEditable: col.dataIndex === firstEditableDataIndex,
            isLastEditable: col.dataIndex === lastEditableDataIndex,
            inputProps: col.inputProps || {},
            type: col.type,
            dataIndex: col.dataIndex,
            title: col.title,
            getInput: getInput,
            save: save,
            cancel: cancel,
            onInputBlur: onInputBlur,
            onInputFocus: onInputFocus,
            mapValuesToForm: mapValuesToForm,
            undoText: props.locale.undo,
            editOnFocus: editOnFocus || col.editOnFocus,
            cellChangeTrigger: col.cellChangeTrigger || false,
            focusedHighlight: focusedHighlight || false,
            tooltipProps: col.tooltipProps || {},
            cellStyle: col.cellStyle || function (record, rowId) {} || '',
            rowIndex: col.rowIndex || null,
            size: props.size
          };
        }
      });
    };

    // modifty action butttons
    return columnsDef.map(_modifyColumns);
  }
  //#endregion

  //#region side effects

  (0, _react.useEffect)(function () {
    setColumns(mapColums(columnsFromProps));
  }, [columnsFromProps, save, cancel, onInputBlur, mapValuesToForm, getInput, props.locale.undo, isCellMode ? isCellMode : editingKey]);
  (0, _react.useEffect)(function () {
    if (onEditingKeyChange) {
      onEditingKeyChange(editingKey);
    }
  }, [editingKey]);
  (0, _react.useEffect)(function () {
    if (ondataIndexChange) {
      ondataIndexChange(selectedDataIndex);
    }
  }, [selectedDataIndex]);
  (0, _react.useEffect)(function () {
    if (isCellMode) {
      if (editingKey === '' && selectedDataIndex === null) {
        if (containerRef.current && submitingElementClassName.current) {
          // https://stackoverflow.com/questions/497094/how-do-i-find-out-which-dom-element-has-the-focus
          // if nothnig is focused we can focus back to classNamed element
          if (!(document.hasFocus() && document.activeElement !== null && document.activeElement !== document.body && document.activeElement !== document.documentElement)) {
            var elements = containerRef.current.getElementsByClassName(submitingElementClassName.current);
            if (elements && elements[0] && elements[0].focus) {
              elements[0].focus();
            }
          }
        }
      }
    }
  }, [editingKey, selectedDataIndex]);

  //#endregion

  // table wrapped with form and added submit input for supporting submit on enter
  return /*#__PURE__*/_react.default.createElement("form", {
    ref: containerRef,
    onSubmit: handleSubmit,
    className: "editable-table-wrapper-form"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, rest, {
    components: {
      body: {
        cell: isCellMode ? _SingleEditableCell.default : _EditableCell.default,
        row: _EditableRow.default
      }
    },
    onRow: onRow,
    data: data,
    columns: columns,
    pagination: pagination,
    tableClassName: isCellMode ? 'editable-cell ' + className : 'editable-row' + className,
    onChange: onTableChange,
    rowKey: rowKey,
    onInputFocus: onInputFocus,
    isEditMode: !!editingKey
  })), /*#__PURE__*/_react.default.createElement("input", {
    type: "submit",
    className: "hidden"
  }));
}
function EditableTableContainer(props) {
  var rowKey = props.rowKey,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_EditableTableContext.EditableTableFormProvider, {
    editingRowKey: props.editingRowKey,
    onFormValuesChange: props.onFormValuesChange,
    rowKey: rowKey
  }, /*#__PURE__*/_react.default.createElement(EditableTable, (0, _extends2.default)({}, rest, {
    rowKey: rowKey
  })));
}
EditableTableContainer.getInput = defaultGetInput;
var _default = exports.default = EditableTableContainer;